/* ============================================================
   Online Queso — Shopify theme client-side enhancement.
   Ported from the redesign mockup (site.js): mobile menu,
   "Load more", brand-hero cheese-hole effect, and newsletter
   success toggle. The HTML is rendered by Liquid sections.
   ============================================================ */
(function () {
  'use strict';

  // ---- Mobile menu + search bar + Load more (delegated) -------------------
  var menu = document.querySelector('.oq-mobile-menu');
  var searchBar = document.querySelector('.oq-search-bar');
  var searchBtn = document.querySelector('.oq-search-btn');

  function closeSearch() {
    if (!searchBar || !searchBar.classList.contains('is-open')) return;
    searchBar.classList.remove('is-open');
    if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-act]');
    if (!t) return;
    var act = t.getAttribute('data-act');
    if (act === 'toggle-menu') {
      var open = menu && menu.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) closeSearch();
    } else if (act === 'toggle-search') {
      if (!searchBar) return;
      var sOpen = searchBar.classList.toggle('is-open');
      t.setAttribute('aria-expanded', sOpen ? 'true' : 'false');
      if (sOpen) {
        // Both panels slide under the header — only one open at a time.
        if (menu) menu.classList.remove('is-open');
        var hb = document.querySelector('.oq-hamburger');
        if (hb) hb.setAttribute('aria-expanded', 'false');
        var inp = searchBar.querySelector('input[type="search"]');
        if (inp) inp.focus();
      }
    } else if (act === 'load-more') {
      var hidden = document.querySelectorAll('.grid-cell.is-hidden');
      for (var i = 0; i < hidden.length; i++) hidden[i].classList.remove('is-hidden');
      var wrap = t.closest('.load-more-wrap');
      if (wrap) wrap.remove();
    }
  });
  if (menu) {
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) menu.classList.remove('is-open');
    });
  }
  if (searchBar) {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        if (searchBar.classList.contains('is-open')) {
          closeSearch();
          if (searchBtn) searchBtn.focus();
        }
      }
    });
    // Separate from the delegated listener: that one bails without [data-act].
    document.addEventListener('click', function (e) {
      if (!searchBar.classList.contains('is-open')) return;
      if (e.target.closest('.oq-search-bar') || e.target.closest('.oq-search-btn')) return;
      closeSearch();
    });
  }

  // ---- Related posts: shuffle + limit so each load rotates the set ---------
  // The server renders a pool of same-category posts; we shuffle (Fisher-Yates)
  // on every page load and keep the first N, so a refresh surfaces a different
  // set/order. Client-side, so Shopify's full-page cache can't freeze it.
  var relScrollers = document.querySelectorAll('.related-scroller[data-related-show]');
  for (var rs = 0; rs < relScrollers.length; rs++) {
    (function (sc) {
      var show = parseInt(sc.getAttribute('data-related-show'), 10) || 10;
      var cells = Array.prototype.slice.call(sc.querySelectorAll('.related-cell'));
      for (var i = cells.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = cells[i]; cells[i] = cells[j]; cells[j] = t;
      }
      for (var k = 0; k < cells.length; k++) {
        if (k >= show) { cells[k].parentNode.removeChild(cells[k]); }
        else { sc.appendChild(cells[k]); } // re-append in shuffled order
      }
      sc.removeAttribute('hidden');
    })(relScrollers[rs]);
  }

  // ---- Newsletter: submit via fetch so the page never jumps to the top -----
  // The native Shopify customer form does a full POST + reload (scrolling to
  // top, hiding the success panel). We intercept it, POST in the background,
  // and reveal the success panel in place.
  var newsForm = document.getElementById('oq-news-form');
  if (newsForm) {
    newsForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var ok = document.getElementById('oq-news-success');
      var data = new FormData(newsForm);
      fetch(newsForm.getAttribute('action') || '/contact', {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'text/html' }
      }).then(function () {
        newsForm.hidden = true;
        if (ok) ok.hidden = false;
      }).catch(function () {
        // On any network error, fall back to a normal submit.
        newsForm.submit();
      });
    });
  }
  // Also handle the legacy full-reload success flag (if JS-fetch was bypassed).
  if (/[?&]customer_posted=true/.test(window.location.search)) {
    var f = document.getElementById('oq-news-form');
    var s = document.getElementById('oq-news-success');
    if (f) f.hidden = true;
    if (s) s.hidden = false;
    var sec = document.getElementById('oq-newsletter');
    if (sec) sec.scrollIntoView({ block: 'center' });
  }

  // ---- Brand-hero cheese holes -------------------------------------------
  (function initCheeseHoles() {
    var hero = document.querySelector('.brand-hero');
    var layer = document.getElementById('oq-holes');
    if (!hero || !layer) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var active = [];
    var GAP = 8;
    var timer = null;

    var heroRect = hero.getBoundingClientRect();
    hero.querySelectorAll('.edge-hole').forEach(function (eh) {
      var b = eh.getBoundingClientRect();
      active.push({ x: b.left - heroRect.left + b.width / 2, y: b.top - heroRect.top + b.height / 2, r: b.width / 2 });
    });

    function spawnOne() {
      var rect = hero.getBoundingClientRect();
      var size = Math.random() < 0.28 ? (80 + Math.random() * 95) : (12 + Math.random() * 46);
      var r = size / 2;
      for (var attempt = 0; attempt < 12; attempt++) {
        var x = r + Math.random() * (rect.width - size);
        var y = r + Math.random() * (rect.height - size);
        var clear = true;
        for (var i = 0; i < active.length; i++) {
          var a = active[i];
          if (Math.hypot(x - a.x, y - a.y) < r + a.r + GAP) { clear = false; break; }
        }
        if (!clear) continue;
        var rec = { x: x, y: y, r: r };
        active.push(rec);
        var hole = document.createElement('span');
        hole.className = 'cheese-hole';
        hole.style.left = x + 'px';
        hole.style.top = y + 'px';
        hole.style.width = size + 'px';
        hole.style.height = size + 'px';
        layer.appendChild(hole);
        hole.addEventListener('animationend', function () {
          this.remove();
          var idx = active.indexOf(rec);
          if (idx > -1) active.splice(idx, 1);
        });
        return;
      }
    }

    var mm = window.matchMedia;
    var noHover = !mm || mm('(hover: none)').matches || mm('(pointer: coarse)').matches || window.innerWidth <= 880;
    if (noHover) {
      spawnOne();
      timer = setInterval(spawnOne, 200);
      return;
    }
    hero.addEventListener('mouseenter', function () {
      if (timer) return;
      spawnOne();
      timer = setInterval(spawnOne, 130);
    });
    hero.addEventListener('mouseleave', function () {
      clearInterval(timer); timer = null;
    });
  })();
})();
